import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { getTemplatePageComponent } from "./registry";
import {
  TemplateTrackingProvider,
  useTemplateResolved,
  useTemplateName,
  useTemplateTrack,
} from "./TemplateTrackingProvider";
import * as actions from "../../redux/actions/catalogActions";

function TemplatePageResolverInner({
  pageKey,
  fallbackComponent: FallbackComponent,
  catalog,
  actions: catalogActions,
}) {
  const codename = useTemplateName();
  const templateReady = useTemplateResolved();
  const track = useTemplateTrack();
  const resolvedCodename = getTemplatePageComponent(codename, pageKey)
    ? codename
    : "original";
  const TemplateComponent =
    getTemplatePageComponent(codename, pageKey) || FallbackComponent;

  React.useEffect(() => {
    if (!templateReady) return;
    track("public_page_view", {
      meta: {
        pageKey,
        path:
          typeof window !== "undefined"
            ? window.location.pathname
            : null,
      },
    });
  }, [pageKey, templateReady, track]);

  return (
    <TemplateTrackingProvider codename={resolvedCodename}>
      <TemplateComponent catalog={catalog} actions={catalogActions} />
    </TemplateTrackingProvider>
  );
}

TemplatePageResolverInner.propTypes = {
  pageKey: PropTypes.string.isRequired,
  fallbackComponent: PropTypes.elementType.isRequired,
  catalog: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = (state) => ({
  catalog: state.catalogReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplatePageResolverInner);
